/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "地址电话",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "address",
                name: "所在位置",
                type: "address"
            },
            {
                key: "is_map_show",
                name: "地图显示",
                type: "radio-box",
                "radio-list": [{
                        label: "不显示地图",
                        value: 0
                    },
                    {
                        label: "显示地图",
                        value: 1
                    }
                ]
            },
            {
                key: "mobile",
                name: "联系电话",
                type: "text"
            },
            {
                key: "is_mobile_show",
                name: "电话显示",
                type: "radio-box",
                "radio-list": [{
                        label: "不显示电话",
                        value: 0
                    },
                    {
                        label: "显示电话",
                        value: 1
                    }
                ]
            },
            {
                key: "map_icon",
                name: "地图图标",
                type: "img",
                memo: "建议宽度：60px*60px",
                defaultImg: "https://img.mockuai.com/tms/2018/1/17/upload_007ade71fde095e383667e3a0f7a7831.png"
            },
            {
                key: "mobile_icon",
                name: "电话图标",
                type: "img",
                memo: "建议宽度：60px*60px",
                defaultImg: "https://img.mockuai.com/tms/2018/1/17/upload_d24253e96d8a3843fdd62cf444b02352.png"
            }
        ]
    }
];

export default config;